export default __webpack_public_path__ + "static/media/Group1497-Yono2@3x.5f270f13.png";